import Head from 'next/head'
// Types
import type {Ballot} from '../types/ballot'

interface ClientMetaProps {
  ballot?: Ballot
  pageTitle?: string
}

const ClientMeta = ({
  ballot,
  pageTitle,
}: ClientMetaProps) => {
  // // TODO: Consider the following formats/size restrictions
  // //       https://evilmartians.com/chronicles/how-to-favicon-in-2021-six-files-that-fit-most-needs
  // //       Currently, we are not even restricting the image to a square, and are allowing Flickr files?
  // //       This needs to be locked down
  // <link rel="icon" href="/favicon.ico"><!-- 32×32 -->
  // <link rel="icon" href="/icon.svg" type="image/svg+xml">
  // <link rel="apple-touch-icon" href="/apple-touch-icon.png"><!-- 180×180 -->
  // <link rel="manifest" href="/manifest.webmanifest">
  const ballotMeta = ballot?.general?.meta_info?.content
  // NOTE: title will be overwritten if the client adds <title> to their ballot.header.html (out of our control)
  const title = (ballotMeta?.title) || pageTitle
  const metadescription = ballotMeta?.metadescription
  const metaogtitle = ballotMeta?.metaogtitle
  const metaogdescription = ballotMeta?.metaogdescription
  const metaogimage = ballotMeta?.metaogimage
  const metaogurl = ballotMeta?.metaogurl
  const metatwittercard = ballotMeta?.metatwittercard
  const metaogsite_name = ballotMeta?.metaogsite_name
  const metatwitterimagealt = ballotMeta?.metatwitterimagealt
  const fbapp_id = ballotMeta?.fbapp_id
  const metatwittersite = ballotMeta?.metatwittersite
  const favicon = ballot?.general?.favicon?.url
  const headerCss = (ballot?.header?.header_type === 'custom') && ballot?.header?.css

  const hasContent = (
    title
    || metadescription
    || metaogtitle
    || metaogdescription
    || metaogimage
    || metaogurl
    || metatwittercard
    || metaogsite_name
    || metatwitterimagealt
    || fbapp_id
    || metatwittersite
  )

  return hasContent
    ? (
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        {title && <title>{title}</title>}
        {metadescription && <meta property="description" content={metadescription} key="metadescription"/>}
        {metaogtitle && <meta property="og:title" content={metaogtitle} key="metaogtitle"/>}
        {metaogdescription && <meta property="og:description" content={metaogdescription} key="metaogdescription"/>}
        {metaogimage && <meta property="og:image" content={metaogimage} key="metaogimage"/>}
        {metaogurl && <meta property="og:url" content={metaogurl} key="metaogurl"/>}
        {metaogsite_name && <meta property="og:site_name" content={metaogsite_name} key="metaogsite_name"/>}
        {metatwittercard && <meta property="twitter:card" content={metatwittercard} key="metatwittercard"/>}
        {metatwitterimagealt && <meta property="twitter:image:alt" content={metatwitterimagealt} key="metatwitterimagealt"/>}
        {fbapp_id && <meta property="fb:app_id" content={fbapp_id} key="metafbapp_id"/>}
        {metatwittersite && <meta property="twitter:site" content={metatwittersite} key="metatwittersite"/>}
        {favicon && <link rel="icon" type="image/png" href={favicon} key="favicon"/>}
        {headerCss && <style type="text/css" media="screen">{headerCss}</style>}
      </Head>
    )
    : null
}

export default ClientMeta
